<template>
  <router-link v-if="route.routeType === 'internal'" :aria-label="route.label" :to="route.link" replace>
    <div class="flex justify-between border-b border-b-grey-100 py-4 hover:bg-grey-15 active:bg-grey-15">
      <div class="flex flex-row items-center gap-2 font-semibold text-type-secondary">
        <gv-icon v-if="route.icon" size="xs" :name="route.icon" class="fill-secondary" />
        {{ route.title }}
      </div>
      <gv-icon name="chevron_right" class="fill-grey-400" />
    </div>
  </router-link>

  <a v-else-if="route.routeType === 'external'" :href="route.link" target="_blank" rel="noopener noreferrer">
    <div class="flex justify-between border-b border-b-grey-100 py-4 hover:bg-grey-15 active:bg-grey-15">
      <div class="flex flex-row items-center gap-2 font-semibold text-type-secondary">
        <gv-icon v-if="route.icon" size="xs" :name="route.icon" class="fill-secondary" />
        {{ route.title }}
      </div>
      <gv-icon name="chevron_right" class="fill-grey-400" />
    </div>
  </a>

  <button v-else class="flex justify-between border-b border-b-grey-100 py-4" @click="emit('clickModal')">
    <div class="flex justify-between border-b border-b-grey-100 pb-4 hover:bg-grey-15 active:bg-grey-15">
      <div class="flex flex-row items-center gap-2 font-semibold text-type-secondary">
        <gv-icon v-if="route.icon" size="xs" :name="route.icon" class="fill-secondary" />
        {{ route.title }}
      </div>
      <gv-icon name="chevron_right" class="fill-grey-400" />
    </div>
  </button>
</template>

<script setup lang="ts">
import { RouteConfig } from '@/common/types';

defineProps<{ route: RouteConfig }>();

const emit = defineEmits(['clickModal']);
</script>
